/**
 * Created by Pradeep Kumar on 5/23/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ISpinConfig} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TweenLite} from "gsap";
import {TombOfNefertitiReelStopPresentationController} from "../../reelStopPresentation/TombOfNefertitiReelStopPresentationController";
import {TombOfNefertitiFreeSpinIntroView} from "../../screen/freespinintro/TombOfNefertitiFreeSpinIntroView";
import {TombOfNefertitiParsedGameData} from "../../server/data/TombOfNefertitiParsedGameData";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {TombOfNefertitiReelAreaView} from "./TombOfNefertitiReelAreaView";

export class TombOfNefertitiReels extends Reels {

    private _isCurseFeatureTriggered:boolean = false;
    private _attentionIndexes:number[] = [];
    private _nextRespinPositions:number[] = [];
    private _mode:string;
    private _isRestore:boolean = false;
    private _scatterCount:number = 0;
    private _hasWin:boolean = false;
    public static thirdScatterId:number = -1;

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, TombOfNefertitiFreeSpinIntroView.FREESPIN_INTRO_TRANSITION_IN, (event:GameEvent) => this.fadeReels(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:TombOfNefertitiParsedGameData):void {
        this._mode = data.mode;
        this._isCurseFeatureTriggered = data.isCurseFeatureTriggered || data.isCurseFeatureReSpinTriggered || (data.nextReelSetName === "CURSE_REELSET");
        this._attentionIndexes = data.indexesForAttention;
        this.getNextRespinPositions(data.respinPositions);
        this._scatterCount = TombOfNefertitiReels.getScatterCount(data.scatterPositions as any);
        this._isRestore = (data as any).isRestoreState;
        this._hasWin = data.betWins && data.betWins.length > 0;
    }

    protected onBeforeSpinStart():void {
        super.onBeforeSpinStart();

        if(this._isCurseFeatureTriggered && (this._nextRespinPositions.length !== 0)) {
            EventHandler.dispatchEvent(new GameEvent("syncReelsOnSpinStart"));
        }

        if(this._isRestore) {
            return;
        }

        if(this._mode.indexOf(GameMode.FREESPIN) !== -1) {
            return;
        }

        if((this._nextRespinPositions.length > 0) && (this._scatterCount >= 2)) { //(this._attentionIndexes.length > 0)) {
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiReelStopPresentationController.ADD_SCATTER_ATTENTION, this._nextRespinPositions));
        } else {
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiReelStopPresentationController.CLEAR_ATTENTION_FROM_REEL, -1));
        }
    }

    protected onSpinStart(config:ISpinConfig):void {
        super.onSpinStart(config);
        (Reels._reelAreaView as TombOfNefertitiReelAreaView).onSpinStart();
    }

    // overridden to loop reel spin sound.
    protected onReelSpinStarted(reelId:number):void {
        this._reelsSpinStates[reelId] = true;
        this._reelsActualSpinningStates[reelId] = true;
        if(this._reelsSpinStates.indexOf(false) === -1) {
            if(SoundConfig.instance.REELS_SPINNING != null) {
                SlotGame.sound.playEffect(SoundConfig.instance.REELS_SPINNING, -1);
                this._isSpinSoundPlaying = true;
            }
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STARTED));
        }
    }

    private static getScatterCount(scatterPositions:boolean[][] | undefined):number {
        if(!scatterPositions) {
            return 0;
        }
        let scatterCount = 0;
        TombOfNefertitiReels.thirdScatterId = -1;

        for(let i:number = 0; i < scatterPositions.length; i++) {
            for(let j:number = 0; j < scatterPositions[i].length; j++) {
                if(scatterPositions[i][j]) {
                    scatterCount++;
                }
                if(TombOfNefertitiReels.thirdScatterId === -1 && scatterCount === 3) {
                    TombOfNefertitiReels.thirdScatterId = i * 3 + j;
                }
            }
        }
        return scatterCount;
    }

    private fadeReels(direction:string):void {
        if(direction === 'IN') {
            SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_INTRO);

            TweenLite.to(Reels._reelAreaView, 1, {alpha : 0});
            TweenLite.to(StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.IDLE.name), 1, {alpha : 0}); // to hide the layer while going into free spins (you may see idle L syms while transition is taking place)
        } else {
            TweenLite.to(Reels._reelAreaView, 1, {alpha : 1});
            TweenLite.to(StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.IDLE.name), 1, {alpha : 1});
        }
    }

    private getNextRespinPositions(respinArr:boolean[]):void {
        this._nextRespinPositions = [];
        for(let i = 0; i < respinArr.length; i++) {
            let reelNearWin:any = respinArr[i] as any;

            for(let j = 0; j < reelNearWin.length; j++) {
                if(reelNearWin[j]) {
                    this._nextRespinPositions.push(i * 3 + j);
                }
            }
        }
    }
}